export class Location {
    latitude = 0;
    longitude = 0;
    elevation = 0;
}
